import axios from './axiosInstances/axiosInstance';

export const setTipBasketAmount = (basketId, amount) => {
  return axios.put(`baskets/${basketId}/tip`, {
    tipAmount: amount,
  });
};
